<script setup lang="ts">
    import type { Component, HTMLAttributes } from 'vue';
    import type { AlertVariants } from '.';
    import { cn } from '../utils';
    import { InformationCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, ShieldCheckIcon } from '@heroicons/vue/20/solid';
    import { alertVariants } from '.';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        variant?: AlertVariants['variant'];
        /**
         * Icon component. If undefined - default icon for variant, if null - no icon
         */
        icon?: Component | null;
    }>();

    const iconComponent = computed(() => {
        if (props.icon) return props.icon;
        if (props.icon === null) return;

        switch (props.variant) {
            case 'info':
            case 'neutral':
                return InformationCircleIcon;
            case 'warning':
                return ExclamationCircleIcon;
            case 'destructive':
                return ExclamationTriangleIcon;
            case 'positive':
                return ShieldCheckIcon;
            default:
                return null;
        }
    });
</script>

<template>
    <div
        data-slot="alert"
        :class="cn(alertVariants({ variant }), props.class)"
        role="alert"
    >
        <component
            :is="iconComponent"
            v-if="iconComponent"
        />

        <slot />
    </div>
</template>
